import React from 'react'
import { translate } from 'utils/translations'
import GenerateTab from './GenerateTab'
import HistoryTab from './HistoryTab'
import { TTabKey, ITabData } from './types'
import { T } from 'consts/translationKeys'
import { TabKey } from './consts'

export const TABS: ITabData[] = [
  {
    key: TabKey.GENERATE,
    label: translate(T.GENERATE_LABEL),
    content: <GenerateTab />
  },
  {
    key: TabKey.HISTORY,
    label: translate(T.VERSION_HISTORY_LABEL),
    content: <HistoryTab />
  }
]

export const getTabsData = (): { name: TTabKey; text: string }[] =>
  TABS.map(tab => ({
    name: tab.key,
    text: tab.label
  }))

export const getTabContent = (key: string): React.ReactNode => {
  const tab = TABS.find(t => t.key === key)
  return tab?.content || null
}
